import React from "react";
import {
  Box,
  CircularProgress,
  CssBaseline,
  Typography,
} from "@material-ui/core";
import Hooks from "@hooks";

export const ReleaseNotes: React.FC = () => {
  const [settings, , settings_fetching] = Hooks.useSettings();

  const releaseNotes = React.useMemo(
    () => (settings ? settings.releaseNotes : ""),
    [settings]
  );

  return settings_fetching ? (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      color="text.disabled"
    >
      <Box p={1}>
        <CircularProgress size="1em" />
      </Box>
      <Typography variant="caption" color="inherit">
        Loading Release Notes
      </Typography>
    </Box>
  ) : settings ? (
    <CssBaseline>
      <div dangerouslySetInnerHTML={{ __html: releaseNotes }} />
    </CssBaseline>
  ) : null;
};
